/**
 * Definisce il routing e le relative views
 * <pre>
 * App
 *  |
 *  |------> Login
 *  |
 *  |------> Home
 *             |
 *             |----> Menu
 *             |        |
 *             |        |----> menuContent
 *             |        |
 *             |        |----> menuEdit
 *             |
 *             |----> Libreria
 *             |        |
 *             |        |----> editTapi
 *             | 
 *             |----> Tavoli
 *             |        |
 *             |        |----> editTavolo
 *             |        |
 *             |        |----> ordinaTavolo
 *             |
 *             |----> Listini
 *             |        |
 *             |        |----> editListino
 *             |
 *             |----> Ordini
 *             |
 *             |----> Impostazioni
 * </pre>
 * @module router/Index
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    // Each of these routes are loaded asynchronously, when a user first navigates to each corresponding endpoint.
    // The route will load once into memory, the first time it's called, and no more on future calls.
    // This behavior can be observed on the network tab of your browser dev tools.
    {
      path: '/login',
      name: 'login',
      component: function (resolve) {
        require(['@/components/login/Login.vue'], resolve)
      }
    },
    {
      path: '/',
      name: 'home',
      component: function (resolve) {
        require(['@/components/home/Home.vue'], resolve)
      },
      redirect: '/libreria',
      beforeEnter: guardRoute,
      children: [
        {
          path: 'libreria',
          name: 'libreria',
          icon: 'list',
          meta: {
            title: 'Libreria',
          },
          toMenu: true,
          activeIf: ['libreria', 'editTapi'],
          component: function(resolve) {
            require(['@/components/lib/Lib.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'edit-tapi',
          name: 'editTapi',
          component: function(resolve) {
            require(['@/components/common/ProdEditor.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'menu',
          name: 'menu',
          icon: 'restaurant_menu',
          meta: {
            title: 'Menu',
          },
          toMenu: true,
          activeIf: ['menu', 'menuContent', 'editMenu'],
          component: function(resolve) {
            require(['@/components/menu/Menu.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'menu-content',
          name: 'menuContent',
          component: function(resolve) {
            require(['@/components/common/MenuContent.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'edit-menu',
          name: 'editMenu',
          component: function(resolve) {
            require(['@/components/common/MenuEditor.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'tavoli',
          name: 'tavoli',
          icon: 'looks_3',
          meta: {
            title: 'Tavoli',
          },
          toMenu: true,
          activeIf: ['tavoli', 'editTavolo'],
          component: function(resolve) {
            require(['@/components/tavoli/Tavoli.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'edit-tavolo',
          name: 'editTavolo',
          component: function(resolve) {
            require(['@/components/common/TavoloEditor.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'ordina-tavolo',
          name: 'ordinaTavolo',
          component: function(resolve) {
            require(['@/components/common/ordinaTavolo.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'listini',
          name: 'listini',
          icon: 'monetization_on',
          meta: {
            title: 'Listini',
          },
          toMenu: true,
          activeIf: ['listini', 'editListini'],
          component: function(resolve) {
            require(['@/components/listini/Listini.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'edit-listino',
          name: 'editListino',
          component: function(resolve) {
            require(['@/components/common/ListinoEditor.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'ordini',
          name: 'ordini',
          icon: 'playlist_add_check',
          meta: {
            title: 'Ordini',
          },
          toMenu: true,
          activeIf: ['ordini'],
          component: function(resolve) {
            require(['@/components/ordini/Ordini.vue'], resolve)
          },
          beforeEnter: clearActions
        },
        {
          path: 'settings',
          name: 'settings',
          icon: 'settings',
          meta: {
            title: 'Impostazioni',
          },
          toMenu: true,
          activeIf: ['settings'],
          component: function(resolve) {
            require(['@/components/settings/Settings.vue'], resolve)
          },
          beforeEnter: clearActions
        }
      ]
    }
  ]
})

/** Pulisce il titolo e le azioni della toolbar prima di cambiare views */
function clearActions(to, from, next) {
  router.app.$options.store.dispatch('TOOLBAR_ACTIONS',[])
  router.app.$options.store.dispatch('TOOLBAR_TITLE', null)
  next()
}

/** Reindirizza a login se non loggato */
function guardRoute (to, from, next) {
  // work-around to get to the Vuex store (as of Vue 2.0)
  const auth = router.app.$options.store.state.auth
  if (!auth.isLoggedIn) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js